





























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component
export default class Tarotble extends Vue {
    private artist: string = '';
    private track: string = '';
    private tarotReading = '';
    private spinner: boolean = false;
    private message: string = '';

    private async fetchReading() {
        // call api with axios probably or something
        if (this.track === '' || this.artist === '') {
            this.showMessage('Both the artist and track names must be provided.');
            return
        }
        this.spinner = true;
        try {        
            let response = await axios.get('https://tarotble-r5rhqak6kq-uc.a.run.app/lyrics',
                                           {params: {track: this.track, artist: this.artist}});
            console.log(response);
            this.tarotReading = response['data']['data'];
            this.spinner = false;
        } catch (err) {
            console.log(err);
            this.showMessage(err['response']['data']['message']);
            this.spinner = false;
        }
        
    }
    private showMessage(msg: string, time = 2000) {
        this.message = msg;
        if (time > 0) {
            setTimeout(() => {
                this.message = '';
            }, time);
        }
    }
}

